import { useEffect } from "react";

const SEO = ({ pageTitle }) => {
  useEffect(() => {
    const baseTitle = "Ayyıldız İnşaat";

    if (!pageTitle || pageTitle.trim() === "" || pageTitle === baseTitle) {
      document.title = baseTitle;
    } else {
      document.title = `${baseTitle} - ${pageTitle}`;
    }
  }, [pageTitle]);

  return null;
};

export default SEO;